import React from 'react';
import classNames from 'classnames';

import VerticalBookCardEmpty from 'rebook/apps/books/components/VerticalBookCardEmpty';

import styles from './style.scss';


const DashboardBookListEmpty = ({ picture }) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <div className={styles.contentImage} />
    </div>
    <div className={classNames(picture && styles.titleWhite, styles.title)} />
    <div className={styles.slider}>
      {[...Array(5)].map((item, key) => (
        <VerticalBookCardEmpty key={key} />
      ))}
    </div>
  </div>
);

export default DashboardBookListEmpty;
